import { getAuthState } from '../hooks/useAuth';

export interface SearchResultData {
    cnpj_completo: string;
    razao_social: string;
    nome_fantasia: string;
    uf: string;
    municipio: string;
    bairro: string;
    cep: string;
    logradouro: string;
    cnae_principal: string;
    porte: string;
    email: string;
    dominio_email: string;
    telefone: string;
    facebook: string;
    instagram: string;
    linkedin: string;
    whatsapp: string;
    socios: string;
    capital_social: string;
    mei: string;
    dados_empresa?: object[];
    dados_pessoas?: object[];
  }

let auth = getAuthState()

export const apSaveEnrichment = async (path: string, result: SearchResultData[]): Promise<object> => {
    try {
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/ap`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                path: path,
                result: result
            })
        });
        const data = await response.json();
        return JSON.parse(data.body);
    } catch (error) {
        console.error('Error fetching files:', error);
        return [];
    }
};